export const INHERIT_FONT_FAMILY = 'inherit';
export const DEFAULT_FONT_FAMILY = [
  '-apple-system',
  'BlinkMacSystemFont',
  'Segoe UI',
  'Roboto',
  'Helvetica',
  'Arial',
  'sans-serif',
  'Apple Color Emoji',
  'Segoe UI Emoji',
  'Segoe UI Symbol',
].join(',');

export const LAYOUT_TYPE_DEFAULT = 'DEFAULT';
export const LAYOUT_TYPE_IN_POPUP = 'IN_POPUP';

export const LAYOUT_TYPE_ENUMS = [LAYOUT_TYPE_DEFAULT, LAYOUT_TYPE_IN_POPUP] as const;
